import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAdmin } from '../context/AdminContext'

const ImpersonationBanner = () => {
  const { impersonating, stopImpersonation } = useAdmin()
  const navigate = useNavigate()
  
  // Handle exit - stop impersonating and return to admin dashboard
  const handleExit = () => {
    stopImpersonation()
    navigate('/admin')
  }
  
  // Escape key exits impersonation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && impersonating) {
        handleExit()
      }
    }
    
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [impersonating])
  
  // Don't render anything if not impersonating
  if (!impersonating) return null
  
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-3 flex-wrap">
          {/* Eye icon */}
          <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          
          <span className="font-semibold">
            Assisting:
          </span>
          
          <span className="font-medium">
            {impersonating.fullName || 'Unknown'}
          </span>
          
          {impersonating.companyName && (
            <span className="text-amber-800">
              ({impersonating.companyName})
            </span>
          )}
          
          {impersonating.stage && (
            <span className="text-xs bg-amber-600 text-white px-2 py-0.5 rounded font-medium">
              {impersonating.stage}
            </span>
          )}
        </div>
        
        <div className="flex items-center gap-3">
          {/* Keyboard hint */}
          <span className="hidden sm:inline text-xs text-amber-800">
            Press <kbd className="px-1.5 py-0.5 bg-amber-400 rounded text-amber-900 font-mono">Esc</kbd> to exit
          </span>
          
          {/* Exit button */}
          <button
            onClick={handleExit}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-sm font-medium transition-colors"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Exit Assistance Mode
          </button>
        </div>
      </div>
    </div>
  )
}

export default ImpersonationBanner
